// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"179bc564","239":"1aab785e","453":"08d06068","732":"a30eb744"}[chunkId] + ".chunk.js";
};